import { RequestError } from '../requestError';
import api from '../axiosBase';
import { getURL } from '../serviceHelper';
import { getEnv } from '../../AppConfigs';
import { ISoftware } from '../../models/ISoftware';

const SPSiteId = getEnv('REACT_APP_SP_SITE_ID');
const SPSysMgtListId = getEnv('REACT_APP_SYSTEM_MGMT_SP_LIST_ID');
const SPMailTemplateListId = getEnv('REACT_APP_MAIL_TEMPLATE_SP_LIST_ID');

export class SystemMgmtService {
  static async getSoftwares(): Promise<ISoftware[]> {
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPSysMgtListId}/items?&expand=fields`))
      .then(res => res.data.value && res.data.value.map((o: any) => ({ id: o.id, ...o.fields })))
      .catch(err => { throw new RequestError(err) });
  }
  static async getMailTemplates() {
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPMailTemplateListId}/items?&expand=fields`))
      .then(res => res.data.value && res.data.value.map((o: any) => ({ ...o.fields })))
      .catch(err => { throw new RequestError(err) });
  }

  static async addSoftware(fields: any) {
    return api.post(getURL(`/sites/${SPSiteId}/lists/${SPSysMgtListId}/items`), fields)
      .then(res => res)
      .catch(err => { throw new RequestError(err) });
  }

  static async updateSoftware(id: any, fields: any) {
    return api.patch(getURL(`/sites/${SPSiteId}/lists/${SPSysMgtListId}/items/${id}/fields`), fields)
      .then(res => res)
      .catch(err => { throw new RequestError(err) });
  }

  static async deleteSoftware(id: any, listId?: string) {
    return api.delete(getURL(`/sites/${SPSiteId}/lists/${SPSysMgtListId}/items/${id}`))
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }
}
